import { render, staticRenderFns } from "./card-gift.vue?vue&type=template&id=687382ee&scoped=true&"
import script from "./card-gift.vue?vue&type=script&lang=ts&"
export * from "./card-gift.vue?vue&type=script&lang=ts&"
import style0 from "./card-gift.vue?vue&type=style&index=0&id=687382ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687382ee",
  null
  
)

export default component.exports